var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarVs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 37,
    viewBox: "0 0 43 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1474_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 29,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18042 6.17822H35.8202V30.8218H7.18042V6.17822Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1474_88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1474_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 29,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5003 6.17822C13.5916 6.17822 7.18042 11.6948 7.18042 18.5C7.18042 25.3052 13.5916 30.8218 21.5003 30.8218C29.409 30.8218 35.8202 25.3052 35.8202 18.5C35.8202 11.6948 29.409 6.17822 21.5003 6.17822Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1474_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.18042 6.17822H35.8202V30.8218H7.18042V6.17822Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1474_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 20,
    height: 37
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7356 0.00964355H30.9714V36.9897H11.7356V0.00964355Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1474_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.417 23.1819L14.4679 23.3027L12.5545 10.8717L15.7273 10.7747C15.9624 13.5998 16.3551 17.7919 16.5723 20.5932L17.2211 20.5733C18.1699 17.858 20.2408 13.3429 21.3852 10.6026L25.0738 10.4934C22.7932 14.7201 20.5767 18.9719 18.42 23.2462L18.417 23.1819ZM15.7198 30.1721C21.1538 20.2541 26.3466 10.2294 30.9662 0.0106812C29.0312 3.26553 27.2059 6.56726 25.4068 9.87799L25.406 9.86514L20.8753 9.99876C20.0034 12.0749 17.9497 16.7069 17.1457 18.7503C16.9889 16.7981 16.5552 12.1314 16.3954 10.1356L11.7356 10.2782L13.8386 23.9406L18.1363 23.8095C15.9497 28.1731 13.8027 32.5527 11.8274 36.9908C13.1712 34.7374 14.453 32.4576 15.7198 30.1721Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1474_88",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 15,
    width: 15,
    height: 15
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 15.4019H31.3327V29.1066H17.625V15.4019Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1474_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0729 16.499C29.2289 15.4609 26.3496 15.1507 24.2496 15.7089L24.4668 16.2986C25.9263 15.7365 29.5276 16.2684 30.3988 16.8613L29.2185 18.8449C28.4951 18.419 26.2525 17.8518 25.2522 18.392C24.2802 18.8102 24.2115 19.8785 24.8871 20.4508C25.6538 21.2293 27.4171 22.2224 27.8964 23.1564C28.6429 24.2722 28.2592 25.7278 27.5231 26.7055C25.7994 29.1567 20.6969 28.6595 18.5797 27.5213L19.6719 25.485C20.77 26.0368 22.2183 26.4691 23.5158 26.3329C24.8864 26.2076 25.5501 24.8972 24.6423 23.9703C23.9226 23.2316 22.1616 22.1935 21.7129 21.3623L21.0903 21.6745C21.5419 22.525 23.2993 23.6099 24.0719 24.3493C24.4407 24.7283 24.4377 25.2338 24.0062 25.5216C22.667 26.1685 20.4916 25.2826 19.3733 24.5606L17.6682 27.741C21.3269 29.9661 28.36 29.7226 28.9915 24.982C29.4395 21.7824 25.4941 21.0116 25.1514 19.4641C25.3754 18.0991 28.8004 19.1776 29.155 19.5399L29.4947 19.7423L31.3334 16.6525L31.0729 16.499Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6653 29.6777C16.3544 31.7776 15.1943 33.9603 14.356 36.2337C15.1883 35.0723 15.8841 33.8409 16.5418 32.6011C17.1883 31.3569 17.8019 30.0953 18.267 28.7913C18.0543 29.081 17.8587 29.3784 17.6653 29.6777Z",
    fill: "#FF2E2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6425 8.54599C25.9541 6.44611 27.1105 4.26208 27.9511 1.99005C27.1195 3.15208 26.4237 4.38285 25.7653 5.62196C25.118 6.86621 24.5036 8.12845 24.04 9.43245C24.2535 9.14274 24.4491 8.84533 24.6425 8.54599Z",
    fill: "#1DCADC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarVs);
export default __webpack_public_path__ + "static/media/avatarVS.43044f8550eb1037ba1368986a602441.svg";
export { ForwardRef as ReactComponent };